module.exports = __webpack_public_path__ + "media/images/meta/kinrgy/apple-touch-icon-98860e0ede2dfd87a0be60a806ba931d.png";